import { getEnumValueLabel, TranslateLike } from './helper';

const ORDER_STATUS_KEY_MAP = {
  ALL: 'order.status.all',
  WAITING_PAY: 'order.status.unpaid',
  WAITING_DELIVERY: 'order.status.toShip',
  WAITING_SIGN: 'order.status.inTransit',
  TRADE_SUCCESS: 'order.status.completed',
  CANCEL: 'order.status.cancelled',
  REFUND: 'order.status.returnRefund',
  IN_CANCELING: 'order.status.canceling',
  MULTIPLE_STATUS: 'order.status.mixedStatus',
  UNKNOWN_ORDER_STATUS: 'order.status.unknown',
} as const;

const RETURN_REFUND_LOGISTICS_STATUS_KEY_MAP = {
  LE_CHAT_NOT_START: 'order.returnRefund.logistics.status.notShipped',
  LE_CHAT_PACKAGE_LOST: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_PACKAGE_RETURN_SUCCESS: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_PACKAGE_SCRAPPED: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_RETURN_FAIL_SCRAPPED: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_RETURN_FAIL_WAIT_SELLER_PICK: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_SEND_FAIL: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_SIGNED: 'order.returnRefund.logistics.status.received',
  LE_CHAT_TRADE_CLOSED: 'order.returnRefund.logistics.status.orderClosed',
  LE_CHAT_UNKNOWN_TRACE: 'order.returnRefund.logistics.status.unknown',
  LE_CHAT_WAITING_COLLECT: 'order.returnRefund.logistics.status.deliveryNotStarted',
  LE_CHAT_WAITING_SEND: 'order.returnRefund.logistics.status.outForDelivery',
  LE_CHAT_WAITING_SIGN: 'order.returnRefund.logistics.status.awaitingReceipt',
} as const;

export const getOrderStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, ORDER_STATUS_KEY_MAP);

export const getReturnRefundLogisticsStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, RETURN_REFUND_LOGISTICS_STATUS_KEY_MAP);

const LOGISTICS_SHIPMENT_STATUS_KEY_MAP = {
  LE_CHAT_NOT_START: 'logistics.shipmentStatus.notShipped',
  LE_CHAT_WAITING_COLLECT: 'logistics.shipmentStatus.pendingCollection',
  LE_CHAT_WAITING_SEND: 'logistics.shipmentStatus.outForDelivery',
  LE_CHAT_WAITING_SIGN: 'logistics.shipmentStatus.awaitingReceipt',
  LE_CHAT_SIGNED: 'logistics.shipmentStatus.delivered',
  LE_CHAT_PACKAGE_LOST: 'logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_PACKAGE_RETURN_SUCCESS: 'logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_PACKAGE_SCRAPPED: 'logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_RETURN_FAIL_SCRAPPED: 'logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_RETURN_FAIL_WAIT_SELLER_PICK: 'logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_SEND_FAIL: 'logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_TRADE_CLOSED: 'logistics.shipmentStatus.orderClosed',
  LE_CHAT_UNKNOWN_TRACE: 'logistics.shipmentStatus.unknown',
} as const;

const ERP_SHIPMENT_STATUS_KEY_MAP = {
  CREATED: 'logistics.erpShipmentStatus.pendingCollection',
  IN_TRANSIT: 'logistics.erpShipmentStatus.inTransit',
  OUT_FOR_DELIVERY: 'logistics.erpShipmentStatus.outForDelivery',
  DELIVERED: 'logistics.erpShipmentStatus.delivered',
  NOT_FOUND: 'logistics.erpShipmentStatus.notFound',
  UNDELIVERABLE: 'logistics.erpShipmentStatus.exception',
} as const;

export const getLogisticsShipmentStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, LOGISTICS_SHIPMENT_STATUS_KEY_MAP);

export const getErpShipmentStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, ERP_SHIPMENT_STATUS_KEY_MAP);
